// Copyright 2017 Sorama B.V.

import { autoinject, BindingEngine, Disposable, transient } from "aurelia-framework";
import { Size } from "controls/plot/IPlotPart";
import { IWorkflowModuleLifetime } from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { IMeasurementPreviewService } from "services/Measurement/IMeasurementPreviewService";

/**
 * MODULE OPERATION DESCRIPTION - VideoModule
 * Shows a video stream of the currently used capture device (measurement device)
 * Other properties that are controlled in this module are (workflowproperty or router paths):
 * - None as of yet
 */
@transient()
@autoinject
export class VideoModule implements IWorkflowModuleLifetime {
    private streamAddress: string;
    public aspectSize: Size = { width: 16, height: 9 };

    private disposables: Disposable[];
    private updatePromise: Promise<void>;

    constructor(
        private readonly previewService: IMeasurementPreviewService,
        private readonly bindingEngine: BindingEngine
    ) {}

    public activateModule(): void {
        this.disposables = [
            this.bindingEngine
                .propertyObserver(this.previewService, "isVideoAvailable")
                .subscribe(this.isVideoAvailableChanged),
        ];

        this.isVideoAvailableChanged();
    }

    public deactivateModule(): void {
        while (this.disposables.length > 0) this.disposables.pop().dispose();
    }

    private isVideoAvailableChanged = (): void => {
        const promise = this.updatePromise ? this.updatePromise : Promise.resolve();

        this.updatePromise = promise.then(() => {
            if (this.previewService.isVideoAvailable.available) {
                return this.previewService
                    .getResolution()
                    .then((resolution) => {
                        this.aspectSize = resolution;
                        return this.previewService.getStreamAddress().then((address) => {
                            this.streamAddress = address;
                        });
                    })
                    .catch(() => {});
            } else {
                this.streamAddress = undefined;
            }
        });
    };
}
